module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createSuccess"
  }, [_c('mt-header', {
    attrs: {
      "title": "发布成功"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "right"
    },
    on: {
      "click": function($event) {
        return _vm.goToJob()
      }
    },
    slot: "right"
  }, [_vm._v("完成")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('icon', {
    attrs: {
      "name": "check-circle"
    }
  }), _vm._v("发布成功")], 1), _vm._v(" "), _c('p', [_vm._v("项目发送成功!请等待审核，平台项目管家会在工作日一小时内和您电话联系，请您注意接听。")])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToJob()
      }
    }
  }, [_vm._v("知道了")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6d0a922","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/createSuccess.vue
// module id = 1294
// module chunks = 1